function UForm(formId) {
  this.isCompanyContainer = null;
  this.companyContainer = null;
  this.titleContainer = null;
  this.firstNameContainer = null;
  this.lastNameContainer = null;
  this.addressContainer = null;
  this.address2Container = null;
  this.address3Container = null;
  this.address4Container = null;
  this.address5Container = null;
  this.address6Container = null;
  this.address7Container = null;
  this.address8Container = null;
  this.address9Container = null;
  this.zipContainer = null;
  this.cityContainer = null;
  this.stateContainer = null;
  this.countryContainer = null;
  this.telContainer = null;
  this.mobileContainer = null;
  this.birthDateContainer = null;
  this.emailContainer = null;
  this.passwordContainer = null;
  this.passwordConfirmContainer = null;
  this.vipCodeContainer = null;
  this.optional1Container = null;
  this.optional2Container = null;
  this.optional3Container = null;
  this.optional4Container = null;
  this.optional5Container = null;
  this.newsletterContainer = null;
  this.smsContainer = null;
  this.catalogContainer = null;
  this.conditionsContainer = null;
  this.customOptin1Container = null;
  this.customOptin2Container = null;
  this.customOptin3Container = null;
  this.streetNumberContainer = null;

  this.isCompanyField = null;
  this.companyField = null;
  this.titleField = null;
  this.firstNameField = null;
  this.lastNameField = null;
  this.addressField = null;
  this.address2Field = null;
  this.address3Field = null;
  this.address4Field = null;
  this.address5Field = null;
  this.address6Field = null;
  this.address7Field = null;
  this.address8Field = null;
  this.address9Field = null;
  this.zipField = null;
  this.cityField = null;
  this.stateField = null;
  this.countryField = null;
  this.telField = null;
  this.mobileField = null;
  this.birthDayField = null;
  this.birthMonthField = null;
  this.birthYearField = null;
  this.emailField = null;
  this.passwordField = null;
  this.passwordConfirmField = null;
  this.vipCodeField = null;
  this.optional1Field = null;
  this.optional2Field = null;
  this.optional3Field = null;
  this.optional4Field = null;
  this.optional5Field = null;
  this.newsletterField = null;
  this.smsField = null;
  this.catalogField = null;
  this.conditionsField = null;
  this.customOptin1Field = null;
  this.customOptin2Field = null;
  this.customOptin3Field = null;
  this.streetNumberField = null;

  this.$stateCache = null;
  this.id = formId;
}
UForm.prototype = {
  isCompany: function isCompany(value) {
    if (!this.isCompanyField) {
      return undefined;
    }
    if (value !== undefined) {
      this.isCompanyField.prop('checked', value);
      this.isCompanyField.trigger('change');
    }
    return this.isCompanyField.is(':checked');
  },

  company: function company(value) {
    if (!this.companyField) {
      return undefined;
    }
    if (value !== undefined) {
      this.companyField.val(value);
      this.companyField.trigger('change');
      if (value !== null && value.length > 0) {
        this.isCompanyField.prop('checked', true);
        this.companyContainer.show();
      } else {
        this.isCompanyField.prop('checked', false);
        this.companyContainer.hide();
      }
    }
    return this.companyField.val();
  },

  title: function title(value) {
    if (!this.titleContainer) {
      return undefined;
    }
    if (value !== undefined) {
      if (value === '') {
        this.titleContainer.find('input').prop('checked', false);
      } else {
        this.titleContainer.find(`input[value='${value}']`).prop('checked', true);
      }
      this.titleContainer.find('input').trigger('change');
    }
    return this.titleContainer.find('input:checked').val();
  },

  firstName: function firstName(value) {
    if (!this.firstNameField) {
      return undefined;
    }
    if (value !== undefined) {
      this.firstNameField.val(value);
      this.firstNameField.trigger('change');
    }
    return this.firstNameField.val();
  },

  lastName: function lastName(value) {
    if (!this.lastNameField) {
      return undefined;
    }
    if (value !== undefined) {
      this.lastNameField.val(value);
      this.lastNameField.trigger('change');
    }
    return this.lastNameField.val();
  },

  address: function address(value) {
    if (!this.addressField) {
      return undefined;
    }
    if (value !== undefined) {
      this.addressField.val(value);
      this.addressField.trigger('change');
    }
    return this.addressField.val();
  },

  address2: function address2(value) {
    if (!this.address2Field) {
      return undefined;
    }
    if (value !== undefined) {
      this.address2Field.val(value);
      this.address2Field.trigger('change');
    }
    return this.address2Field.val();
  },

  address3: function address3(value) {
    if (!this.address3Field) {
      return undefined;
    }
    if (value !== undefined) {
      this.address3Field.val(value);
      this.address3Field.trigger('change');
    }
    return this.address3Field.val();
  },

  address4: function address4(value) {
    if (!this.address4Field) {
      return undefined;
    }
    if (value !== undefined) {
      this.address4Field.val(value);
      this.address4Field.trigger('change');
    }
    return this.address4Field.val();
  },

  address5: function address5(value) {
    if (!this.address5Field) {
      return undefined;
    }
    if (value !== undefined) {
      this.address5Field.val(value);
      this.address5Field.trigger('change');
    }
    return this.address5Field.val();
  },

  address6: function address6(value) {
    if (!this.address6Field) {
      return undefined;
    }
    if (value !== undefined) {
      this.address6Field.val(value);
      this.address6Field.trigger('change');
    }
    return this.address6Field.val();
  },

  address7: function address7(value) {
    if (!this.address7Field) {
      return undefined;
    }
    if (value !== undefined) {
      this.address7Field.val(value);
      this.address7Field.trigger('change');
    }
    return this.address7Field.val();
  },

  address8: function address8(value) {
    if (!this.address8Field) {
      return undefined;
    }
    if (value !== undefined) {
      this.address8Field.val(value);
      this.address8Field.trigger('change');
    }
    return this.address8Field.val();
  },

  address9: function address9(value) {
    if (!this.address9Field) {
      return undefined;
    }
    if (value !== undefined) {
      this.address9Field.val(value);
      this.address9Field.trigger('change');
    }
    return this.address9Field.val();
  },

  zip: function zip(value) {
    if (!this.zipField) {
      return undefined;
    }
    if (value !== undefined) {
      this.zipField.val(value);
      this.zipField.trigger('change');
    }
    return this.zipField.val();
  },

  city: function city(value) {
    if (!this.cityField) {
      return undefined;
    }
    if (value !== undefined) {
      this.cityField.val(value);
      this.cityField.trigger('change');
    }
    return this.cityField.val();
  },

  state: function state(value) {
    if (!this.stateField || !this.$stateCache) {
      return undefined;
    }
    if (value !== undefined) {
      this.stateField.val(value);
      this.$stateCache.val(value);
      this.stateField.trigger('change');
    }
    const result = this.$stateCache.val();
    const listValue = this.stateField.val();
    if (result === undefined || result === null) {
      return listValue;
    }
    if (result !== undefined && result !== null && (listValue === undefined || listValue === null
      || result.toUpperCase() !== listValue.toUpperCase())) {
      this.stateField.val(this.$stateCache.val());
    }
    return result;
  },

  country: function country(value) {
    if (!this.countryField) {
      return undefined;
    }
    if (value !== undefined) {
      this.countryField.val(value);
      this.countryField.trigger('change');
    }
    return this.countryField.val();
  },

  tel: function tel(value) {
    if (!this.telField) {
      return undefined;
    }
    if (value !== undefined) {
      this.telField.val(value);
      this.telField.trigger('change');
    }
    return this.telField.val();
  },

  mobile: function mobile(value) {
    if (!this.mobileField) {
      return undefined;
    }
    if (value !== undefined) {
      this.mobileField.val(value);
      this.mobileField.trigger('change');
    }
    return this.mobileField.val();
  },

  birthDate: function birthDate(value) {
    if (!this.birthDateContainer) {
      return undefined;
    }
    const $day = this.birthDateContainer.find("select[name$='DateOfBirth_Day']");
    const $month = this.birthDateContainer.find("select[name$='DateOfBirth_Month']");
    const $year = this.birthDateContainer.find("select[name$='DateOfBirth_Year']");
    if (value !== undefined) {
      $day.val(value.getDate());
      $month.val(value.getMonth());
      $year.val(value.getFullYear());
      this.birthDateField.trigger('change');
    }
    const result = new Date();
    result.setDate($day.val());
    result.setMonth($month.val());
    result.setFullYear($year.val());
    return result;
  },

  birthMonth: function birthMonth(value) {
    if (!this.birthDateContainer) {
      return undefined;
    }
    const $month = this.birthDateContainer.find("select[name$='DateOfBirth_Month']");
    if (value !== undefined) {
      $month.val(value);
      this.birthMonthField.trigger('change');
    }
    return $month.val();
  },

  birthYear: function birthYear(value) {
    if (!this.birthDateContainer) {
      return undefined;
    }
    const $year = this.birthDateContainer.find("select[name$='DateOfBirth_Year']");
    if (value !== undefined) {
      $year.val(value);
      this.birthYearField.trigger('change');
    }
    return $year.val();
  },

  birthDay: function birthDay(value) {
    if (!this.birthDateContainer) {
      return undefined;
    }
    const $day = this.birthDateContainer.find("select[name$='DateOfBirth_Day']");
    if (value !== undefined) {
      $day.val(value);
      this.birthDayField.trigger('change');
    }
    return $day.val();
  },

  email: function email(value) {
    if (!this.emailField) {
      return undefined;
    }
    if (value !== undefined) {
      this.emailField.val(value);
      this.emailField.trigger('change');
    }
    return this.emailField.val();
  },

  password: function password(value) {
    if (!this.passwordField) {
      return undefined;
    }
    if (value !== undefined) {
      this.passwordField.val(value);
      this.passwordField.trigger('change');
    }
    return this.passwordField.val();
  },

  passwordConfirm: function passwordConfirm(value) {
    if (!this.passwordConfirmField) {
      return undefined;
    }
    if (value !== undefined) {
      this.passwordConfirmField.val(value);
      this.passwordConfirmField.trigger('change');
    }
    return this.passwordConfirmField.val();
  },

  vipCode: function vipCode(value) {
    if (!this.vipCodeField) {
      return undefined;
    }
    if (value !== undefined) {
      this.vipCodeField.val(value);
      this.vipCodeField.trigger('change');
    }
    return this.vipCodeField.val();
  },

  optional1: function optional1(value) {
    if (!this.optional1Field) {
      return undefined;
    }
    if (value !== undefined) {
      this.optional1Field.val(value);
      this.optional1Field.trigger('change');
    }
    return this.optional1Field.val();
  },

  optional2: function optional2(value) {
    if (!this.optional2Field) {
      return undefined;
    }
    if (value !== undefined) {
      this.optional2Field.val(value);
      this.optional2Field.trigger('change');
    }
    return this.optional2Field.val();
  },

  optional3: function optional3(value) {
    if (!this.optional3Field) {
      return undefined;
    }
    if (value !== undefined) {
      this.optional3Field.val(value);
      this.optional3Field.trigger('change');
    }
    return this.optional3Field.val();
  },

  optional4: function optional4(value) {
    if (!this.optional4Field) {
      return undefined;
    }
    if (value !== undefined) {
      this.optional4Field.val(value);
      this.optional4Field.trigger('change');
    }
    return this.optional4Field.val();
  },

  optional5: function optional5(value) {
    if (!this.optional5Field) {
      return undefined;
    }
    if (value !== undefined) {
      this.optional5Field.val(value);
      this.optional5Field.trigger('change');
    }
    return this.optional5Field.val();
  },

  newsletter: function newsletter(value) {
    if (!this.newsletterField) {
      return undefined;
    }
    if (value !== undefined) {
      this.newsletterField.prop('checked', value);
      this.newsletterField.trigger('change');
    }
    return this.newsletterField.is(':checked');
  },

  sms: function sms(value) {
    if (!this.smsField) {
      return undefined;
    }
    if (value !== undefined) {
      this.smsField.prop('checked', value);
      this.smsField.trigger('change');
      if (value === true) {
        this.mobileField.addClass('required');
      } else if (value === false && this.mobileField.hasClass('already-required') === false) {
        this.mobileField.removeClass('required');
      }
    }
    return this.smsField.is(':checked');
  },

  catalog: function catalog(value) {
    if (!this.catalogField) {
      return undefined;
    }
    if (value !== undefined) {
      this.catalogField.prop('checked', value);
      this.catalogField.trigger('change');
    }
    return this.catalogField.is(':checked');
  },

  conditions: function conditions(value) {
    if (!this.conditionsField) {
      return undefined;
    }
    if (value !== undefined) {
      this.conditionsField.prop('checked', value);
      this.conditionsField.trigger('change');
    }
    return this.conditionsField.is(':checked');
  },

  customOptin1: function customOptin1(value) {
    if (!this.customOptin1Field) {
      return undefined;
    }
    if (value !== undefined) {
      this.customOptin1Field.prop('checked', value);
      this.customOptin1Field.trigger('change');
    }
    return this.customOptin1Field.is(':checked');
  },

  customOptin2: function customOptin2(value) {
    if (!this.customOptin2Field) {
      return undefined;
    }
    if (value !== undefined) {
      this.customOptin2Field.prop('checked', value);
      this.customOptin2Field.trigger('change');
    }
    return this.customOptin2Field.is(':checked');
  },

  customOptin3: function customOptin3(value) {
    if (!this.customOptin3Field) {
      return undefined;
    }
    if (value !== undefined) {
      this.customOptin3Field.prop('checked', value);
      this.customOptin3Field.trigger('change');
    }
    return this.customOptin3Field.is(':checked');
  },
  streetNumber: function streetNumber(value) {
    if (!this.streetNumberField) {
      return undefined;
    }
    if (value !== undefined) {
      this.streetNumberField.val(value);
      this.streetNumberField.trigger('change');
    }
    return this.streetNumberField.val();
  },

  init: function init(abRegistered) {
    const $containers = $(`[id^='${this.id}'][id$='_Container'], [id^='${this.id}'][id$='_Container_Field']`);

    this.isCompanyContainer = $containers.filter("[id*='company'][id$='_Container']");
    this.companyContainer = $containers.filter("[id*='company'][id$='_Container_Field']");
    this.titleContainer = $containers.filter("[id*='title']");
    this.firstNameContainer = $containers.filter("[id*='firstName']");
    this.lastNameContainer = $containers.filter("[id*='lastName']");
    this.addressContainer = $containers.filter("[id*='address_']");
    this.address2Container = $containers.filter("[id*='address2']");
    this.address3Container = $containers.filter("[id*='address3']");
    this.address4Container = $containers.filter("[id*='address4']");
    this.address5Container = $containers.filter("[id*='address5']");
    this.address6Container = $containers.filter("[id*='address6']");
    this.address7Container = $containers.filter("[id*='address7']");
    this.address8Container = $containers.filter("[id*='address8']");
    this.address9Container = $containers.filter("[id*='address9']");
    this.zipContainer = $containers.filter("[id*='zip']");
    this.cityContainer = $containers.filter("[id*='city']");
    this.stateContainer = $containers.filter("[id*='state']");
    this.countryContainer = $containers.filter("[id*='country']");
    this.telContainer = $containers.filter("[id*='tel']");
    this.mobileContainer = $containers.filter("[id*='mobile']");
    this.birthDateContainer = $containers.filter("[id*='birthDate']");
    this.emailContainer = $containers.filter("[id*='email']");
    this.passwordContainer = $containers.filter("[id*='password_']");
    this.passwordConfirmContainer = $containers.filter("[id*='passwordConfirm']");
    this.vipCodeContainer = $containers.filter("[id*='vipCode']");
    this.optional1Container = $containers.filter("[id*='optional1']");
    this.optional2Container = $containers.filter("[id*='optional2']");
    this.optional3Container = $containers.filter("[id*='optional3']");
    this.optional4Container = $containers.filter("[id*='optional4']");
    this.optional5Container = $containers.filter("[id*='optional5']");
    this.newsletterContainer = $containers.filter("[id*='newsletter']");
    this.smsContainer = $containers.filter("[id*='sms']");
    this.catalogContainer = $containers.filter("[id*='catalog']");
    this.conditionsContainer = $containers.filter("[id*='conditions']");
    this.customOptin1Container = $containers.filter("[id*='customOptin1']");
    this.customOptin2Container = $containers.filter("[id*='customOptin2']");
    this.customOptin3Container = $containers.filter("[id*='customOptin3']");
    this.streetNumberContainer = $containers.filter("[id*='streetNumber']");

    const $fields = $(`[data-form='${this.id}']`);

    this.isCompanyField = $fields.filter("[data-id='isCompany']").find("input[type='checkbox']");
    this.companyField = $fields.filter("[data-id='company']");
    this.titleField = $fields.filter("[data-id='title']");
    this.firstNameField = $fields.filter("[data-id='firstName']");
    this.lastNameField = $fields.filter("[data-id='lastName']");
    this.addressField = $fields.filter("[data-id='address']");
    this.address2Field = $fields.filter("[data-id='address2']");
    this.address3Field = $fields.filter("[data-id='address3']");
    this.address4Field = $fields.filter("[data-id='address4']");
    this.address5Field = $fields.filter("[data-id='address5']");
    this.address6Field = $fields.filter("[data-id='address6']");
    this.address7Field = $fields.filter("[data-id='address7']");
    this.address8Field = $fields.filter("[data-id='address8']");
    this.address9Field = $fields.filter("[data-id='address9']");
    this.zipField = $fields.filter("[data-id='zip']");
    this.cityField = $fields.filter("[data-id='city']");
    this.stateField = $fields.filter("[data-id='state']");
    this.countryField = $fields.filter("[data-id='country']");
    this.telField = $fields.filter("[data-id='tel']");
    this.mobileField = $fields.filter("[data-id='mobile']");
    this.birthDayField = $(`#${this.id}_birthDate_Container select[id$='_Day']`);
    this.birthMonthField = $(`#${this.id}_birthDate_Container select[id$='_Month']`);
    this.birthYearField = $(`#${this.id}_birthDate_Container select[id$='_Year']`);
    this.emailField = $fields.filter("[data-id='email']");
    this.passwordField = $fields.filter("[data-id='password']");
    this.passwordConfirmField = $fields.filter("[data-id='passwordConfirm']");
    this.vipCodeField = $fields.filter("[data-id='vipCode']");
    this.optional1Field = $fields.filter("[data-id='optional1']");
    this.optional2Field = $fields.filter("[data-id='optional2']");
    this.optional3Field = $fields.filter("[data-id='optional3']");
    this.optional4Field = $fields.filter("[data-id='optional4']");
    this.optional5Field = $fields.filter("[data-id='optional5']");
    this.newsletterField = $fields.filter("[data-id='newsletter']").find("input[type='checkbox']");
    this.smsField = $fields.filter("[data-id='sms']").find("input[type='checkbox']");
    this.catalogField = $fields.filter("[data-id='catalog']").find("input[type='checkbox']");
    this.conditionsField = $fields.filter("[data-id='conditions']").find("input[type='checkbox']");
    this.customOptin1Field = $fields.filter("[data-id='customOptin1']").find("input[type='checkbox']");
    this.customOptin2Field = $fields.filter("[data-id='customOptin2']").find("input[type='checkbox']");
    this.customOptin3Field = $fields.filter("[data-id='customOptin3']").find("input[type='checkbox']");
    this.streetNumberField = $fields.filter("[data-id='streetNumber']");

    const conditionWrapper = this.conditionsField.closest('[data-id]');
    if (conditionWrapper.length > 0 && conditionWrapper.hasClass('required')) {
      this.conditionsField.attr('class', conditionWrapper.attr('class'));
    }
    const customOptin1Wrapper = this.customOptin1Field.closest('[data-id]');
    if (customOptin1Wrapper.length > 0 && customOptin1Wrapper.hasClass('required')) {
      this.customOptin1Field.attr('class', customOptin1Wrapper.attr('class'));
    }
    const customOptin2Wrapper = this.customOptin2Field.closest('[data-id]');
    if (customOptin2Wrapper.length > 0 && customOptin2Wrapper.hasClass('required')) {
      this.customOptin2Field.attr('class', customOptin2Wrapper.attr('class'));
    }
    const customOptin3Wrapper = this.customOptin3Field.closest('[data-id]');
    if (customOptin3Wrapper.length > 0 && customOptin3Wrapper.hasClass('required')) {
      this.customOptin3Field.attr('class', customOptin3Wrapper.attr('class'));
    }

    this.$stateCache = this.stateContainer.find("[data-id='stateCache']");

    if (this.countryField.length > 0 &&
              this.stateField.length > 0 &&
              (this.countryField.is(':visible') === true || this.id === 'shipping' || this.id === 'billing' || this.id === 'myaccount' || this.id === 'addShippingAddressForm') &&
              this.$stateCache.length > 0 &&
              window.StateList !== undefined &&
              window.StateList !== null) {
      const updateStateList = (value) => {
        const list = window.StateList[value];
        if (list !== undefined &&
                      list !== null &&
                      (value !== 'United Kingdom' || window.GlobalVars.brand === 'MEL')) {
          this.stateField.empty();
          this.stateField.append($(['<option value="" disabled="disabled">--</option>'].join('')));
          list.forEach((key) => {
            this.stateField.append($(['<option value="', key, '">', list[key], '</option>'].join('')));
          });

          this.stateContainer.show();
          this.stateField.addClass('required');
          this.stateField.val(this.$stateCache.val());
          const stateVal = this.stateField.val();
          if (stateVal !== undefined && stateVal !== null && stateVal.toUpperCase()
            !== this.$stateCache.val().toUpperCase()) {
            this.$stateCache.val(stateVal);
          }
        } else {
          this.stateContainer.hide();
          this.stateField.empty();
          this.stateField.removeClass('required');
          this.$stateCache.val('');
        }
      };

      this.countryField.on('change', () => {
        const value = $(this).val();
        updateStateList(value);
      });

      this.stateField.on('change', () => {
        this.$stateCache.val(this.stateField.val());
      });

      if (this.$stateCache.val() !== undefined && this.$stateCache.val() !== null && this.$stateCache.val() !== '') {
        this.stateField.val(this.$stateCache.val());
      } else {
        this.$stateCache.val(this.stateField.val());
      }

      updateStateList(this.country());
    }

    if (this.smsField.length > 0 && this.mobileField.length > 0 && this.smsField.is(':visible') === true) {
      if (this.mobileField.hasClass('required') === true) {
        this.mobileField.addClass('already-required');
      }

      if (this.mobileContainer.is(':visible') === false) {
        this.mobileContainer.addClass('was-hidden');
      }

      if (this.smsField.is(':checked') === true) {
        if (this.mobileField.hasClass('already-required') === false) {
          this.mobileField.addClass('required');
        }
      } else if (this.mobileField.hasClass('already-required') === false) {
        this.mobileField.removeClass('required');
      }

      this.smsField.click(() => {
        if (this.smsField.is(':checked') === true) {
          if (this.mobileField.hasClass('already-required') === false) {
            this.mobileField.addClass('required');
          }
          this.mobileContainer.show();
        } else {
          if (this.mobileField.hasClass('already-required') === false) {
            this.mobileField.removeClass('required');
          }
          if (this.mobileContainer.hasClass('was-hidden') === true) {
            this.mobileContainer.hide();
          }
        }
      });
    }

    if (this.isCompanyField.length > 0 && this.companyField.length > 0) {
      if (this.companyField.hasClass('required') === true) {
        this.companyField.addClass('already-required');
      }

      if (this.isCompanyField.is(':checked') === true) {
        if (this.companyField.hasClass('already-required') === false) {
          this.companyField.addClass('required');
        }
        this.companyContainer.show();
      } else {
        if (this.companyField.hasClass('already-required') === false) {
          this.companyField.removeClass('required');
        }
        this.companyContainer.hide();
      }

      this.isCompanyField.click(() => {
        if (this.isCompanyField.is(':checked') === true) {
          if (this.companyField.hasClass('already-required') === false) {
            this.companyField.addClass('required');
          }
          this.companyContainer.show();
        } else {
          if (this.companyField.hasClass('already-required') === false) {
            this.companyField.removeClass('required');
          }
          this.companyContainer.hide();
        }
      });
    }

    if (this.passwordField.length > 0 && this.passwordConfirmField.length > 0 && this.passwordField.hasClass('required') === true) {
      this.passwordConfirmField.attr('equalTo', ['#', this.passwordField.attr('id')].join(''));
    }

    $(this.isCompanyField, this.companyField, this.titleField, this.firstNameField,
      this.lastNameField, this.addressField, this.address2Field,
      this.address3Field, this.address4Field, this.address5Field,
      this.address6Field, this.address7Field, this.address8Field,
      this.address9Field, this.zipField, this.cityField, this.stateField,
      this.countryField, this.telField, this.mobileField, this.birthDateField,
      this.emailField, this.passwordField, this.passwordConfirmField, this.vipCodeField,
      this.optional1Field, this.optional2Field, this.optional3Field, this.optional4Field,
      this.optional5Field, this.newsletterField, this.smsField, this.catalogField,
      this.conditionsField, this.customOptin1Field, this.customOptin2Field, this.customOptin3Field)
      .on('change', () => {
        $(document).trigger('change.ocms.ultimate-form', [this]);
      });

    if (!abRegistered) {
      $(document).trigger('initialized.ocms.ultimate-form', [this]);
    }
  },
};

function UForms() {}
UForms.prototype = {
  forms: {},
  register: function register(id, forceRegister) {
    let isAlreadyRegistered = typeof this.forms[id] !== 'undefined';
    const form = isAlreadyRegistered ? this.forms[id] : new UForm(id);
    const shouldForceRegister = forceRegister === undefined ? false : forceRegister;

    if (!isAlreadyRegistered) {
      this.forms[id] = form;
    }

    if (shouldForceRegister) {
      isAlreadyRegistered = false;
    }

    form.init(isAlreadyRegistered);

    return form;
  },

  get: function get(id) {
    this.register(id);
    return this.forms[id];
  },

  copy: function copy(sourceId, targetId) {
    const source = this.get(sourceId);
    if (source === undefined || source === null) {
      return;
    }
    const target = this.get(targetId);
    if (target === undefined || target === null) {
      return;
    }

    target.isCompany(source.isCompany);
    target.company(source.company);
    target.title(source.title);
    target.firstName(source.firstName);
    target.lastName(source.lastName);
    target.address(source.address);
    target.address2(source.address2);
    target.address3(source.address3);
    target.address4(source.address4);
    target.address5(source.address5);
    target.address6(source.address6);
    target.address7(source.address7);
    target.address8(source.address8);
    target.address9(source.address9);
    target.zip(source.zip);
    target.city(source.city);
    target.state(source.state);
    target.country(source.country);
    target.tel(source.tel);
    target.mobile(source.mobile);
    target.birthDate(source.birthDate);
    target.email(source.email);
    target.password(source.password);
    target.passwordConfirm(source.passwordConfirm);
    target.vipCode(source.vipCode);
    target.optional1(source.optional1);
    target.optional2(source.optional2);
    target.optional3(source.optional3);
    target.optional4(source.optional4);
    target.optional5(source.optional5);
    target.newsletter(source.newsletter);
    target.sms(source.sms);
    target.catalog(source.catalog);
    target.conditions(source.conditions);
    target.customOptin1(source.customOptin1);
    target.customOptin2(source.customOptin2);
    target.customOptin3(source.customOptin3);
  },
};

function UltimateForm(formId) {
  const newUForm = new UForm(formId);
  return newUForm;
}
function UltimateForms() {
  const newUForms = new UForms();
  return newUForms;
}


OCMS.UltimateForms = UltimateForms();


export {
  UltimateForm,
  UltimateForms,
};



// WEBPACK FOOTER //
// ./js/common/Ultimateform.js